import { Component, ViewChild } from '@angular/core';
import { ReusableInfoConfirmComponent } from '../reusable-info-confirm/reusable-info-confirm.component';
import { InfoAlertComponent } from '../info-alert/info-alert.component';

@Component({
  selector: 'tm-reusable-info-alert',
  templateUrl: './reusable-info-alert.component.html',
  styleUrls: ['./reusable-info-alert.component.css']
})
export class ReusableInfoAlertComponent extends ReusableInfoConfirmComponent {
  /** 實體的訊息確認窗 */
  @ViewChild(InfoAlertComponent, {static: false}) set infoConfirm(c: InfoAlertComponent) {
    if (c) {
      this._infoConfirm = c;
      this.setPendingDatas();
    }
  }
  get infoConfirm() { return this._infoConfirm as InfoAlertComponent; }
}
